import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  const phone = "447717536635";
  const message = encodeURIComponent("Hello, I'd like to learn more about Advaltis Consulting services.");
  const url = `https://wa.me/${phone}?text=${message}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      className="fixed bottom-6 left-6 z-40 w-12 h-12 bg-[#25D366] text-white flex items-center justify-center rounded-full hover:bg-[#20bd5a] transition-all duration-300 shadow-lg hover:shadow-[0_4px_20px_rgba(37,211,102,0.4)] hover:scale-110"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={22} />
    </a>
  );
}
